import { GameCreateFen } from "src/store/models";
import { gameModeText } from "src/store/gameStore/constants/gameModeConst";

import { Divider } from "../../Divider";

import { useStyles } from "./styles";
import { useEffect } from "react";
import { useLocale } from "../../../../../providers/LocaleProvider";

interface IType {
    type: GameCreateFen;
    isMobile?: boolean;
}

export const Type = ({ type, isMobile }: IType) => {
    const classes = useStyles();
    const {
        lobby: {
            gameType: { classic: { classicName } },
        },
    } = useLocale();

    useEffect(() => {
        console.log("Type has been updated:", type);
    }, [type]);

    const getLocalizedGameModeText = (gameType: GameCreateFen) => {
        if (gameType === GameCreateFen.classic) {
            return classicName(gameModeText[gameType]);
        }
        return gameModeText[gameType];
    };

    if (isMobile) {
        return (
            <div className={classes.wrapperType}>
                <span className={classes.label}>{getLocalizedGameModeText(type)}</span>
            </div>
        );
    }

    return (
        <div className={classes.wrapperType}>
            <Divider left={0} />
            <span className={classes.label}>{getLocalizedGameModeText(type)}</span>
            <Divider right={0} />
        </div>
    );
};
